module.exports = __webpack_public_path__ + "static/img/man2.73b048c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/man2.png
// module id = CUjJ
// module chunks = 2